exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".splash-screen {\n  width: 100%;\n  height: 100%;\n  gap: 72px;\n}\n.splash-screen__logo {\n  max-width: 230px;\n}\n", ""]);

